import React, { useState } from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";

import { Button, CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";

import { openSnackbar } from "../../../Redux/Actions/snackbarActions";

import CustomerService from "../../../Service/Customer/customer.service";
import FormControl from "../../MUI_components/FormControl/fomikFormControl";

const AddCustomerFromPos = ({ setOpen }) => {
  const dispatch = useDispatch();

  const initValue = {
    companyName: "",
    customCode: "",
    firstName: "",
    secondName: "",
    phone1: "",
    phone2: "",
    email: "",
    website: "",
    creditLimit: 0,
    creditDays: "",
    isActive: true,
    isVerified: false,
    passportNumber: "",
    nicNumber: "",
    rating: 0,
    notes: "",
    fax: "",
    shipingCode:"",
    customerContacts: [],
    customerAddresses: [
      {
        firstName: "",
        email: "",
        secondName: "",
        phone1: "",
        phone2: "",
        address: "",
        country: "Sri Lanka",
        district: "",
        city: "",
        postBox: "",
        isActive: true,
      },
    ],
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const Validation = yup.object({
    firstName: yup.string().required("Name is Required.."),
    shipingCode: yup.string().required("shiping Code is required"),
    nicNumber: yup.string().min(10).max(12),
    phone1: yup
      .string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Phone Number is Required.."),
  });

  const handleCustomerSubmit = async (values) => {
    try {
      await CustomerService.create(values);
      dispatch(openSnackbar(true, "success", `Customer created successfully`));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  return (
    <>
      <Formik
        initialValues={initValue}
        validationSchema={Validation}
        onSubmit={async (values) => {
          await handleCustomerSubmit(values);
          setOpen(false);
        }}
      >
        {({ isSubmitting }) => (
          <Form autoComplete="off">
            <>
              <div className="row">
                <div className="col-2">
                  <FormControl control="input" name="customCode" label="Code" />
                </div>
                <div className="col-5">
                  <FormControl
                    control="input"
                    name="firstName"
                    label="First Name"
                  />
                </div>
                <div className="col-5">
                  <FormControl
                    control="input"
                    name="secondName"
                    label="Second Name"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-3">
                  <FormControl control="input" name="phone1" label="Contact" />
                </div>
                <div className="col-3">
                  <FormControl
                    control="input"
                    name="nicNumber"
                    label="NIC Number"
                  />
                </div>

                <div className="col-6">
                  <FormControl control="input" name="notes" label="Note" />
                </div>
              </div>
              <div className="row">
            <div className="col-4">
                <FormControl
                  control="input"
                  name="shipingCode"
                  label="Shiping Code"

                />
              </div>
            </div>
            </>
            <div className="row flex-end mb">
              <div style={{ display: "flex" }}>
                <Button
                  disabled={isSubmitting}
                  startIcon={
                    isSubmitting && (
                      <CircularProgress color="inherit" size={20} />
                    )
                  }
                  variant="contained"
                  type="submit"
                  color="secondary"
                >
                  save
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddCustomerFromPos;
